import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent, FunnelCategory, FunnelCategoryService } from 'lib-trend-core';
import { Validators } from 'ngx-editor';

@Component({
    selector: 'app-category-quick-form',
    templateUrl: './category-quick-form.component.html',
    styleUrl: './category-quick-form.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CategoryQuickFormComponent extends AbstractComponent {

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<CategoryQuickFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FunnelCategory,
    private funnelCategoryService: FunnelCategoryService,
  ) {
    super(injector);
    this.setupForm();
  }

  private setupForm(): void {
    this.formGroup = this.formBuilder.group({
      name: [null, [Validators.required]],
      description: [null],
    });
  }

  save(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    const rawVelue = this.formGroup.getRawValue();
    const category = { ...rawVelue, company: super.getCompanyCurrentUser(), };
    this.funnelCategoryService.create(category).pipe()
      .subscribe((categorySaved: FunnelCategory) => {
        this.alertService.success(this.t('kanban.categoryQuickForm.createSuccess'));
        this.dialogRef.close(categorySaved);
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}
